// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option[data-v-184ac7a2] {\n  color: #606266;\n  margin-top: 20px;\n  font-size: small;\n}\n.desc[data-v-184ac7a2] {\n  font-size: small;\n  color: #8c8c8c;\n}\n.org-item[data-v-184ac7a2] {\n  margin: 5px;\n}", ""]);
// Exports
module.exports = exports;
